/*************************************************/
/* Statistic                                     */
/*************************************************/

export function statistic() {
    const statisticValueSelector = '.statistic-value__value';

    const init = function () {
        $(statisticValueSelector).on('addedInViewClass',
            function () {
                var statElement = $(this);

                if (statElement.hasClass('animate')) {

                    statElement.prop('Counter', 0).animate({
                        Counter: statElement.attr("data-value")
                    }, {
                        duration: 3500,
                        easing: 'swing',
                        step: function (now) {
                            $(this).text(Math.ceil(now));
                        }
                    });
                }
            });
    };



    init();
}